import React from 'react';
import { Image as ReactNativeImage, StyleSheet } from 'react-native';

import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { textVariants } from '@/components/lib/typography';
import { usePrevious } from '@/hooks/use-previous';
import { common, withOpacity } from '@/styles/styles';
import { NumberFlow } from 'number-flow-react-native';

import { useCasinoJackpotAmount } from '../hooks/use-casino-jackpot-pool';

const SMALL_TILE_MAX_WIDTH = 120;

const JACKPOT_AMOUNT_FORMAT: Intl.NumberFormatOptions = {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
};

type JackpotTickerProps = {
    imageUri?: string;
    cardWidth: number;
    imageHeight: number;
};

export const JackpotTicker = ({ imageUri, cardWidth, imageHeight }: JackpotTickerProps) => {
    const amount = useCasinoJackpotAmount();
    const previousAmount = usePrevious(amount);

    if (amount === undefined) {
        return null;
    }

    return (
        <Box
            position="absolute"
            left={0}
            right={0}
            bottom={0}
            alignItems="center"
            overflow="hidden"
            paddingHorizontal="s12"
            paddingVertical={cardWidth <= SMALL_TILE_MAX_WIDTH ? 's2' : 's6'}
            style={common.zIndex1}
        >
            {imageUri ? (
                <ReactNativeImage
                    source={{ uri: imageUri }}
                    blurRadius={25}
                    resizeMode="cover"
                    style={[styles.backdrop, { width: cardWidth, height: imageHeight }]}
                />
            ) : null}
            <Box style={[StyleSheet.absoluteFill, styles.fill]} />
            <NumberFlow
                value={amount}
                locales="en-US"
                format={JACKPOT_AMOUNT_FORMAT}
                animated={previousAmount === undefined || amount >= previousAmount}
                style={styles.amount}
            />
        </Box>
    );
};

const styles = StyleSheet.create({
    backdrop: {
        position: 'absolute',
        left: 0,
        bottom: 0,
    },
    fill: {
        // TODO: use background.transparent.subtler (neutral.alpha[10]) once it's added to the Figma semantic tokens
        backgroundColor: withOpacity(ds.colorValue.background.neutral.inverse, 0.1),
    },
    amount: {
        fontSize: textVariants.titleSmall.fontSize,
        fontWeight: textVariants.titleSmall.fontWeight,
        letterSpacing: -0.08,
        color: ds.colorValue.text.primary,
    },
});
